import { render } from "./StyleTab.vue?vue&type=template&id=146d5376&ts=true"
import script from "./StyleTab.vue?vue&type=script&lang=ts"
export * from "./StyleTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__